import { render, staticRenderFns } from "./ViewPost.vue?vue&type=template&id=85585b36&scoped=true"
import script from "./ViewPost.vue?vue&type=script&lang=js"
export * from "./ViewPost.vue?vue&type=script&lang=js"
import style0 from "./ViewPost.vue?vue&type=style&index=0&id=85585b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85585b36",
  null
  
)

export default component.exports